// export const BASE_URL = 'https://api.ospree.io'
// export const BASE_URL = 'https://sandbox.ospree.io'
// export const DEMO_URL = 'https://flowapi-dev-new.ospree.io'
// TODO Switch back to original url
export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://flowapi-dev-new.ospree.io'
export const DEMO_URL = process.env.REACT_APP_DEMO_URL || 'https://sandbox.ospree.io'
export const LOCAL_URL = process.env.REACT_APP_LOCAL_URL || 'http://localhost:8000'
export const USER_SERVICE_URL = process.env.REACT_APP_USER_SERVICE_URL || 'http://localhost:8000'
export const DIRECTORY_SERVICE_URL = process.env.REACT_APP_DIRECTORY_SERVICE_URL || 'http://localhost:8000'
export const TRANSACTION_SERVICE_URL = process.env.REACT_APP_TRANSACTION_SERVICE_URL || 'http://localhost:8000'
export const ADDRESS_SERVICE_URL = process.env.REACT_APP_ADDRESS_SERVICE_URL || 'http://localhost:8000'
export const TRANSFER_SERVICE_URL = process.env.REACT_APP_TRANSFER_SERVICE_URL || 'http://localhost:8000'

export const ADDRESS_ENDPOINTS = {
  GET_ADDRESS_VERIFICATION: '/api/ui/analytics/verification',
  POST_ADDRESS_VERIFICATION: '/api/ui/analytics/verification',
}
